export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; roles?: Array<'user' | 'admin' | 'superAdmin'> }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: '首页',
  },
  routes: [
    // 将各角色的“仪表盘”移动到顶部
    {
      name: 'super-dashboard',
      displayName: '仪表盘',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        roles: ['superAdmin'],
      },
    },
    {
      name: 'new-dashboard',
      displayName: '仪表盘',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        roles: ['user'],
      },
    },
    {
      name: 'admin-dashboard',
      displayName: '仪表盘',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        roles: ['admin'],
      },
    },
    {
      name: 'super-users',
      displayName: '用户管理',
      meta: {
        icon: 'supervisor_account',
        roles: ['superAdmin'],
      },
    },
    {
      name: 'super-subscription',
      displayName: '订阅管理',
      meta: {
        icon: 'subscriptions',
        roles: ['superAdmin'],
      },
    },
    {
      name: 'apps',
      displayName: '应用管理',
      meta: {
        icon: 'apps',
        roles: ['user'],
      },
    },
    {
      name: 'modules',
      displayName: '模块信息',
      meta: {
        icon: 'view_module',
        roles: ['user'],
      },
    },
    {
      name: 'users',
      displayName: '用户管理',
      meta: {
        icon: 'group',
        roles: ['admin'],
      },
    },
    {
      name: 'admin-apps',
      displayName: '应用管理',
      meta: {
        icon: 'app_shortcut',
        roles: ['admin', 'superAdmin'],
      },
    },
    {
      name: 'admin-config',
      displayName: '配置管理',
      meta: {
        icon: 'tune',
        roles: ['admin', 'superAdmin'],
      },
    },
    {
      name: 'admin-versions',
      displayName: '版本管理',
      meta: {
        icon: 'system_update',
        roles: ['admin', 'superAdmin'],
      },
    },
    {
      name: 'admin-features',
      displayName: '功能管理',
      meta: {
        icon: 'view_module',
        roles: ['admin', 'superAdmin'],
      },
    },
    {
      name: 'admin-logs',
      displayName: '日志管理',
      meta: {
        icon: 'view_list',
        roles: ['admin', 'superAdmin'],
      },
    },
    {
      name: 'admin-orders',
      displayName: '订单管理',
      meta: {
        icon: 'receipt_long',
        roles: ['admin', 'superAdmin'],
      },
      children: [
        {
          name: 'admin-orders',
          displayName: '订单列表',
          meta: {
            icon: 'list',
            roles: ['admin', 'superAdmin'],
          },
        },
        {
          name: 'admin-exceptions',
          displayName: '异常账单',
          meta: {
            icon: 'error_outline',
            roles: ['admin', 'superAdmin'],
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: '账户信息',
      meta: {
        icon: 'manage_accounts',
        roles: ['user', 'admin', 'superAdmin'],
      },
    },
  ] as INavigationRoute[],
}
